import ConstructionSection from '../sections/ConstructionSection'

const ConstructionPage = () => <ConstructionSection />

export default ConstructionPage
